import React, { useEffect, useState } from "react"
import { loadReCaptcha, ReCaptcha } from "react-recaptcha-google"
import cx from 'clsx'

import Dropdown from 'src/components/Dropdown'
import countriesList from 'src/utils/countriesList'
import FullPopup from 'src/components/FullPopup'
import { CloseIcon } from 'src/components/Svg'
import { getIpData } from 'src/utils/api'

import s from './contactUsForm.module.scss'

const companySizeArr = [
  { name: '10 - 50' },
  { name: '50 - 200' },
  { name: '200 - 1,000' },
  { name: '1,000 - 10,000' }
]

const ContactUsForm = ({ onSubmit, hasCloseIcon, onClose, classes }) => {
  const [state, setState] = useState({
    country: null,
    phoneNumber: '',
    companySize: companySizeArr[0],
    firstName: '',
    lastName: '',
    email: '',
    description: '',
    isVerifyed: false
  })
  const [errors, setErrors] = useState({
    isVerifyed: false
  })

  const handleChange = (key, value) => setState({ ...state, [key]: value })

  const handleChangeErrors = (key, value) => setErrors({ ...state, [key]: value })

  useEffect(() => {
    getIpData().then(res => {
      countriesList.forEach(country => {
        if (country.code === res.country_code) handleChange('country', country)
      })
    })

    loadReCaptcha()
  }, []) // eslint-disable-line

  useEffect(() => {
    if (state.country) {
      if (state.phoneNumber !== '') {
        const num = state.phoneNumber.split(' ').length > 1 ? state.phoneNumber.split(' ')[1] : ''
        handleChange('phoneNumber', `${state.country.dial_code} ${num}`)
      } else {
        handleChange('phoneNumber', `${state.country.dial_code} `)
      }
    }
  }, [state.country]) // eslint-disable-line

  // const handleChangeReCaptcha = () => {

  // }

  // console.log('recaptchaRef -> ', recaptchaRef)

  const handleSubmit = () => {
    if (state.isVerifyed) {
      onSubmit(state)
    } else {
      handleChangeErrors('isVerifyed', true)
    }
  }

  return (
    <FullPopup classes={classes}>
      {hasCloseIcon ? (
        <div className={s.closeIcon}>
          <CloseIcon onClick={onClose} />
        </div>
      ) : null}

      <div className={s.head}>
        <h1 className={s.title}>Contact Us</h1>
        <p className={s.description}>Contact our consulting team today for hands-on guidance tailored to your team’s specific needs</p>
      </div>

      <form className={s.form}>
        <div className={cx('form-row', s.formRow)}>
          <div className={cx('form-group col-md-6', s.formGroup)}>
            <label className={s.label} htmlFor="firstName">First Name</label>
            <input
              type="text"
              className={cx('form-control', s.myInput)}
              value={state.firstName}
              onChange={e => handleChange('firstName', e.target.value)}
              id="firstName"
            />
          </div>
          <div className={cx('form-group col-md-6', s.formGroup)}>
            <label className={s.label} htmlFor="lastName">Last Name</label>
            <input
              type="text"
              className={cx('form-control', s.myInput)}
              value={state.lastName}
              onChange={e => handleChange('lastName', e.target.value)}
              id="lastName"
            />
          </div>
        </div>

        <div className={cx('form-row', s.formRow)}>
          <div className={cx('form-group col-md-6', s.formGroup)}>
            <label className={s.label} htmlFor="emailInput">Email</label>
            <input
              type="text"
              className={cx('form-control', s.myInput)}
              value={state.email}
              onChange={e => handleChange('email', e.target.value)}
              id="emailInput"
            />
          </div>
          <div className={cx('form-group col-md-3', s.formGroup)}>
            <Dropdown
              list={countriesList}
              selectedItem={state.country}
              keyName="name"
              label="Phone Number"
              placeholder="Select country"
              classes={{ popoverRoot: s.popoverRoot }}
              onChange={selectedValue => handleChange('country', selectedValue)}
            />
          </div>
          <div className={cx('form-group col-md-3', s.formGroupMini)}>
            <label className={s.label} htmlFor="phoneNumber"> </label>
            <input
              type="text"
              className={cx('form-control', s.myInput)}
              id="phoneNumber"
              value={state.phoneNumber}
              onChange={e => handleChange('phoneNumber', e.target.value)}
            />
          </div>
        </div>

        <div className={cx('form-row', s.formRow)}>
          <div className={cx('form-group col-md-6', s.formGroup)}>
            <label className={s.label} htmlFor="companyName">Company name</label>
            <input
              type="text"
              className={cx('form-control', s.myInput)}
              value={state.companyName}
              onChange={e => handleChange('companyName', e.target.value)}
              id="companyName"
            />
          </div>
          <div className={cx('form-group col-md-6', s.formGroup)}>
            <Dropdown
              initialValue={companySizeArr[0]}
              list={companySizeArr}
              keyName="name"
              label="Company Size"
              placeholder="Select company size"
              onChange={selectedValue => handleChange('companySize', selectedValue)}
              searchDisable
            />
          </div>
        </div>

        <div className={cx('form-row', s.formRow)}>
          <div className={cx('form-group col-md-12', s.formGroup)}>
            <label className={s.label} htmlFor="helpYou">How Can Our Team Help You?</label>
            <textarea
              rows="11"
              className={cx('form-control', s.myInput, s.myTextarea)}
              value={state.description}
              onChange={e => handleChange('description', e.target.value)}
              id="helpYou"
              placeholder="…"
            />
          </div>
        </div>
      </form>

      <ReCaptcha
        size="normal"
        render="explicit"
        sitekey="6LeckN0ZAAAAAIe0d6WtDwKDBJrC6xDqYu_WrHPr"
        onloadCallback={() => {
          handleChange('isVerifyed', false)
          handleChangeErrors('isVerifyed', false)
        }}
        verifyCallback={() => {
          handleChange('isVerifyed', true)
          handleChangeErrors('isVerifyed', false)
        }}
      />
      {errors.isVerifyed ? (
        <span className={s.errorText}>Please specify that you're not a robot</span>
      ) : null}

      <div className={s.submit}>
        <button type="submit" className="btn btn-primary" onClick={handleSubmit}>CONTACT US</button>
      </div>
    </FullPopup>
  )
}

export default ContactUsForm
